import { render, staticRenderFns } from "./bills.vue?vue&type=template&id=1fe5fd7f&scoped=true&"
import script from "./bills.vue?vue&type=script&lang=js&"
export * from "./bills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5fd7f",
  null
  
)

export default component.exports